import { formatLayers } from './formatLayers';

export const formatTasks = (tasks: any) =>
  tasks.map((task: any) => ({
    ...task,
    withTheory: task.theoryBlocks && !!task.theoryBlocks.length,
    withHints: task.hintsBlocks && !!task.hintsBlocks.length,
    withMaterials: task.materials && !!task.materials.length,
    withFiles: task.files && !!task.files.length,
    completed: false,
    layers: formatLayers(task.layers),
    errors: [],
  }));
